module.exports = "<div>\n  <h1 class=\"mat-display-1 page-title\">Shane Williamson ~ {{pageTitle}}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/shane/workspace/website/website-client/src/app/banner/banner.component.html
// module id = ../../../../../src/app/banner/banner.component.html
// module chunks = main